import { render, staticRenderFns } from "./PhoneSelector.vue?vue&type=template&id=5793fe2d&scoped=true"
import script from "./PhoneSelector.vue?vue&type=script&lang=js"
export * from "./PhoneSelector.vue?vue&type=script&lang=js"
import style0 from "./PhoneSelector.vue?vue&type=style&index=0&id=5793fe2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5793fe2d",
  null
  
)

export default component.exports